module.exports = __webpack_public_path__ + "static/img/wangshi.85612fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/wangshi.png
// module id = dfht
// module chunks = 0